import { NO_WORKSPACE_UPDATES_PATH, STATUS_UPDATES_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const emptyOrNonProvisionedStatusUpdateStateRoute = createGlobalRoute({
	layout: 'home',
	exact: false,
	name: STATUS_UPDATES_PAGE,
	path: NO_WORKSPACE_UPDATES_PATH,
	subproduct: 'townsquare-empty-state',
});
